import { render, staticRenderFns } from "./list-details-loader.vue?vue&type=template&id=ee424966"
import script from "./list-details-loader.vue?vue&type=script&lang=js"
export * from "./list-details-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports